<script>
export const pageName = 'tools-tracker';
export const pageRoute = '/tools/tracker';
export const title = 'Tracker'

import { loadMaps } from '../../js/googleMaps.js';
import { GeolocationService } from "../../js/lib/geolocation/geolocation-service.js";
import { GeolocationMarker } from "../../js/lib/geolocation/geolocation-marker.js";
import { calcNewCoords } from '../../js/lib/geolocation/geo-math.js';
import { commands, queries } from '../../js/lib/functions.js';
import Modal from '../../js/utils/modal.js';
import { listenToTrackedFlightView } from '../../js/readModel.js';
import { getCurrentUserId } from '../../js/auth.js';
import { showConfirm } from '../../js/utils/confirm.js';
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { replace } from '@trullock/page-manager'
// import QRCode from 'qrcode'

export default {
	data() {
		return {
			lat: 0,
			lng: 0,
			bearing: 0,
			flight: {
				track: {},
				allTracks: []
			},
			tracks: [],
			bearings: [],
			currentTrackIndex: 0,
			collaborators: [],
			collaborated: false,

			cameraStarted: false,
			cameraSupportsZoom: false,
			cameraZoomMin: 0,
			cameraZoomMax: 0,
			cameraZoomStep: 1,
			cameraZoomValue: 0,

			shareSupported: false,

			mapLoaded: false,
			locationFetched: false
		}
	},

	methods: {
		async boot ()
		{
			this.geolocationService = new GeolocationService();
			this.shareSupported = 'share' in navigator;
		},
		showCollaborators()
		{
			if (!this.collaboratorsDialog)
				this.collaboratorsDialog = new Modal(this.$refs.collaborators);
			
			this.collaboratorsDialog.show();
		},
		hideCollaborators()
		{
			this.collaborators = [];
			this.collaboratorsDialog.hide();
		},
		setActiveTrack(i)
		{
			this.currentTrackIndex = i;
			
			for(let b = 0; b < this.bearings.length; b++)
			{
				this.bearings[b].line.setOptions({
					strokeColor: (b == i ? "#0000FF" : "#F6C343")
				})

				this.bearings[b].margin.setOptions({
					fillColor: (b == i ? "#0000FF" : "#F6C343")
				})
			}
		},
		async show() {

			commands.warmUp();
			queries.warmUp();
			
			if(window.location.hostname != 'localhost' && window.location.hostname.indexOf('trullock.uk') == -1)
			{
				await showConfirm({
					title: 'Instructions',
					message: `
	<ul>
		<li>Grant Camera and Location permissions when asked</li>
		<li>Check your compass is properly calibrated, if not, search how to do this for your device</li>
		<li>Have this app open and ready during your launch, ready to capture the landing site</li>
		<li>Point the camera at the landing site of a rocket, get the red line where it lands</li>
		<li>Click Save Location when aligned</li>
		<li>Scroll to the map, see the bearing line on which your rocket landed.</li>
		<li>If a friend also also tagged the landing, have them click Collaborate and then associate their tagging with yours, using your Tracking Code to identify you</li>
		<li>Repeat this with all your friends</li>
		<li>Go find your rocket</li>
		<li>Buy Andrew a beer</li>
	</ul>`,				
					buttons: [
						{
							text: 'Ready',
							style: 'primary',
							action: () => {

							}
						}
					]
				})
			}

			this.mapsLoaded = loadMaps();
		
//////////////////////////////////////////////////////////////////////////
			
			this.cameraStarted = await this.initCamera();
			if(!this.cameraStarted)
			{
				await showConfirm({
					title: 'Camera not available',
					message: 'You either don\'t have a camera or have denied permission to use it. Fix this one way or another.',
					buttons: [
						{
							text: 'OK',
							style: 'primary'
						}
					]
				})
			}

			this.initLocation()

		},
		hide ()
		{
			try
			{
				this.stream.getTracks().forEach(track => {
					track.stop();
				});
			}
			catch(e)
			{

			}
		},
		async initCamera()
		{
			try
			{
				this.stream = await navigator.mediaDevices.getUserMedia({ 
					video: {
						facingMode: 'environment'
					}
				});
				
				this.$refs.camera.srcObject = this.stream;
				this.$refs.camera.play();

				[this.cameraTrack] = this.stream.getVideoTracks();
    			const capabilities = this.cameraTrack.getCapabilities();
				const settings = this.cameraTrack.getSettings();
				this.cameraSupportsZoom =  'zoom' in capabilities;
				if(this.cameraSupportsZoom)
				{
					this.cameraZoomMin = capabilities.zoom.min;
					this.cameraZoomMax = capabilities.zoom.max;
					this.cameraZoomStep = capabilities.zoom.step;
					this.cameraZoomValue = settings.zoom;
				}

				// const devices = await navigator.mediaDevices.enumerateDevices();
				// devices.forEach(device => {
				// 	console.log( "Found device: " + JSON.stringify( device ) );
				// });
				return true;
			}
			catch(e)
			{
				alert(e)
				console.error(e)
				return false;
			}
		},
		zoom() {
			this.cameraTrack.applyConstraints({zoom: this.cameraZoomValue})
				.catch(e => {
					console.error('Error applying zoom constraints:', e)
				});
		},
		async initLocation()
		{
			await this.geolocationService.queryPermissionsState();

			if(this.geolocationService.geolocationPermissionState == 'prompt')
			{
				await this.geolocationService.requestPermissions();
			}
			
			if(this.geolocationService.geolocationPermissionState == 'denied')
			{
				await showConfirm({
					title: 'Location not available',
					message: 'You either don\'t have a location sensors available or have denied permission to use it. Fix this one way or another.',
					buttons: [
						{
							text: 'OK',
							style: 'primary'
						}
					]
				})
			}

			const { Map } = await google.maps.importLibrary("maps");
			const start = {lat: 48, lng: 7};

			this.marker = new GeolocationMarker();
			this.line = new google.maps.Polyline({
				path: [start, calcNewCoords(start, 0, 10000)],
				geodesic: true,
				strokeColor: "#FF0000",
				strokeOpacity: 1.0,
				strokeWeight: 2,
			});
			this.lineMargin = new google.maps.Polygon({
				path: [
					start,
					calcNewCoords(start, -3, 10000),
					calcNewCoords(start, +3, 10000),
				],
				geodesic: true,
				strokeWeight: 0,
				fillColor: "#FF0000",
				fillOpacity: 0.25
			});
			
			this.map = await new Map(this.$refs.map, {
				center: start,
				zoom: 5,
				//mapId: 'khdsfkghdsfg',
				mapTypeId: 'hybrid',
				zoomControl: false,
				cameraControl: false,
				mapTypeControl: true,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: true,
				styles: [
					{
						featureType: "poi",
						stylers: [
							{
								visibility: "off"
							}
						]
					}
				]
			});
			this.map.addListener('tilesloaded', e => {
				this.mapLoaded = true;
			})

			// if the permission had previously been granted, we can immediately start showing the marker
			if (this.geolocationService.geolocationPermissionState === 'granted')
			{
				this.lineMargin.setMap(this.map)
				this.line.setMap(this.map);
				this.marker.setMap(this.map);
				this.geolocationService.start();
			}

			this.geolocationService.addEventListener('update', ev => {
				const {latitude, longitude, accuracy, compassHeading} = ev.detail;
				const hasValidLocation = !isNaN(latitude) && !isNaN(longitude);

				this.marker.accuracy = accuracy;
				this.marker.heading = compassHeading;

				this.bearing = compassHeading || Math.random() * 360;
				this.lat = latitude || 0;
				this.lng = longitude || 0;

				if (hasValidLocation)
				{
					this.locationFetched = true;

					this.marker.position = {lat: latitude, lng: longitude};
					
					this.line.setPath([this.marker.position, calcNewCoords(this.marker.position, this.bearing, 10000)])
					this.lineMargin.setPath([this.marker.position, calcNewCoords(this.marker.position, this.bearing - 3, 10000), calcNewCoords(this.marker.position, this.bearing + 3, 10000)])

					if (!this.mapCenterInitiallyUpdated)
					{
						this.mapCenterInitiallyUpdated = true;

						this.map.setCenter(this.marker.position);
						this.map.setZoom(15);
					}
				}
			});

			this.geolocationService.addEventListener('error', ev => {
				console.log('error occured:', ev.detail);
				this.marker.setMap(null);
				this.line.setMap(null);
				this.geolocationService.stop();
			});
		},
		async trackLanding()
		{
			showLoading();

			const context = this.$refs.cameraCanvas.getContext("2d");
			let width = this.$refs.camera.videoWidth
			let height = this.$refs.camera.videoHeight;

			this.$refs.cameraCanvas.width = width;
			this.$refs.cameraCanvas.height = height;

			context.drawImage(this.$refs.camera, 0, 0, width, height);

			const photo = this.$refs.cameraCanvas.toDataURL("image/png");
			
			// UI QoL: temporarily stash this here whilst we wait for the listener below
			this.tracks.push({
				photoUrl: photo
			})
			this.flight.code = 'Loading...'

			this.stream.getTracks().forEach(track => {
				track.stop();
			});

			let result = await commands.tracking.create({ lat: this.lat, lng: this.lng, bearing: this.bearing, photo: photo })
			this.shareUrl = window.location.protocol + '//' + window.location.host + '/tools/tracker?ownerId=' + encodeURIComponent(getCurrentUserId()) + '&id=' + encodeURIComponent(result.id);
			
			// QRCode.toCanvas(this.$refs.qrcode, window.location.href)

			this.flightListenerUnsub = await listenToTrackedFlightView(getCurrentUserId(), result.id, flight => {
				// flight can be null as the result of a merge, the src flight gets deleted.
				
				this.flight = flight || {};
				this.tracks = this.flight.allTracks || [];
				this.setBearings();
				if(this.tracks.length)
					this.setActiveTrack(0);

				// TODO: abstract this and its counterparts somehow
				this.collaborated = this.tracks.length > 1;
				hideLoading();
			})
			
		},
		async collaborate()
		{
			showLoading();

			let results = await queries.tracking.findCollaborators({ lat: this.lat, lng: this.lng })
			results = results.filter(r => r.id != this.flight.id);
			this.collaborators = results;
			this.showCollaborators();
			hideLoading();
		},
		async merge(dest)
		{
			showLoading();
			let result = await commands.tracking.merge({ destOwnerId: dest.ownerId, destId: dest.id, srcId: this.flight.id})
			//replace('/tools/tracker?ownerId=' + encodeURIComponent(dest.ownerId) + '&id=' + encodeURIComponent(dest.id))
			this.flightListenerUnsub();
			this.flightListenerUnsub = await listenToTrackedFlightView(dest.ownerId, dest.id, flight => {
				this.flight = flight;
				this.tracks = flight.allTracks;
				this.setBearings();
				this.setActiveTrack(0);
			})
			this.collaborated = true;
			this.hideCollaborators();
			hideLoading();
		},
		share()
		{
			navigator.share({
				 url: this.shareUrl
			})
		},
		setBearings()
		{
			for(let bearing of this.bearings)
			{
				bearing.line.setMap(null)
			}
			this.bearings = [];

			// TODO: clear previous lines, store these
			for(let track of this.tracks)
			{
				console.log('track');

				let start = { lat: track.lat, lng: track.lng };

				let line = new google.maps.Polyline({
					path: [start, calcNewCoords(start, track.bearing, 10000)],
					geodesic: true,
					strokeColor: "#0000FF",
					strokeOpacity: 1.0,
					strokeWeight: 2,
				});
				line.setMap(this.map)

				let margin = new google.maps.Polygon({
					path: [
						start,
						calcNewCoords(start, track.bearing - 3, 10000),
						calcNewCoords(start, track.bearing + 3, 10000),
					],
					geodesic: true,
					strokeWeight: 0,
					fillColor: "#0000FF",
					fillOpacity: 0.25
				});
				margin.setMap(this.map)

				this.bearings.push({
					line,
					margin
				});
			}
		}
	}
}

</script>
<template>
	<div class="tracker">
		<canvas ref="cameraCanvas" class="d-none"></canvas>
		
		<div v-for="(track, i) of tracks">
			<img :src="track.photoUrl" v-show="currentTrackIndex == i" class="camera" />
		</div>
		<video v-show="!flight.code" ref="camera" class="camera"></video>
		<div :class="`center-line ${flight.code ? 'primary' : ''}`"></div>
	</div>
	<div v-if="cameraSupportsZoom && !flight.code" class="px-3 mb-n2">
		<div class="row align-items-center">
			<div class="col-auto">
				Zoom:
			</div>
			<div class="col">
				<input type="range" :min="cameraZoomMin" :max="cameraZoomMax" :step="cameraZoomStep" v-model="cameraZoomValue" @input="zoom" class="d-block w-100 my-3" />
			</div>
		</div>
	</div>
	<div v-if="tracks.length > 1" class="px-3 mt-4">
		<div class="row align-items-center mb-4">
			<div v-for="(track, i) of tracks" class="col-auto">
				<button :class="`avatar avatar-lg ${currentTrackIndex == i ? 'active' : ''}`" @click.prevent="setActiveTrack(i)">
					<img class="avatar-img rounded" :src="track.photoUrl">
					<div class="avatar avatar-xs">
						<img class="avatar-img rounded-circle" :src="`${track.userAvatar}`">
					</div>
				</button>
			</div>
		</div>
		<!-- <template v-for="(track, i) of tracks">
			<div v-if="currentTrackIndex == i" class="alert alert-light">
				Tracked by: <strong>{{ track.userName }}</strong>
			</div>
		</template> -->
	</div>
	<div v-if="!flight.code" class="mx-3 my-4">
		<button :disabled="!cameraStarted || !locationFetched || !mapLoaded" class="btn btn-primary btn-block" @click.prevent="trackLanding">Save Location <span class="fe fe-map-pin"></span></button>
	</div>
	<div v-if="flight.code" class="mx-3 my-4">
		<div class="alert alert-light">
			<div class="row align-items-center">
				<div class="col">
					Codeword: <strong>{{ flight.code }}</strong>
				</div>
				<!-- <div class="col">
					<canvas ref="qrcode"></canvas>
				</div> -->
				<div v-if="!collaborated" class="col-auto">
					<button @click.prevent="collaborate" class="btn btn-primary">Collaborate <span class="fe fe-users"></span></button>
				</div>
			</div>
		</div>
	</div>
	<div ref="map" class="" style="height: 75vh"></div>
	<div ref="collaborators" class="modal fade d-none" tabindex="-1" aria-modal="true" role="dialog">
		<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">Select flight to collaborate with</h4>
					<button type="button" class="close text-primary js-close" aria-label="Close">
						<span aria-hidden="true">×</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="list-group list-group-flush my-n3">
						<div v-for="collaborator in collaborators" class="list-group-item">
							<div class="list-group list-group-flush my-n3">
								<div class="list-group-item">
									<div class="row align-items-center">
										<div class="col">
											<h4 class="mb-0">Codeword: {{ collaborator.code }}</h4>
											<small class="text-muted">{{ collaborator.createdOn }}</small>
										</div>
										<div class="col-auto">
											<button class="btn btn-sm btn-outline-primary" @click.prevent="merge(collaborator)">Collaborate <span class="fe fe-users"></span></button>
										</div>
									</div>
									<div v-for="track in collaborator.allTracks" class="row align-items-center ml-5 my-3">
										<div class="col-auto">
											<div class="avatar avatar-sm">
												<img class="avatar-img rounded-circle" :src="track.userAvatar">
											</div>
										</div>
										<div class="col">
											<h4 class="mb-1">{{ track.userName }}</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="collaborators.length == 0" class="list-group-item">
							<div class="row align-items-center">
								<div class="col">
									<h4 class="mb-1 js-name">No collaborators found</h4>
									<p class="text-muted mb-0">There are no recent flights nearby</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
						<p class="text-muted small mb-0">Only UKRA Members' flights can be collaborated with.</p>
						<button v-if="shareSupported" class="btn btn-sm btn-primary" @click.prevent="share">Share <span class="fe fe-share"></span></button>
				</div>
			</div>
		</div>
	</div>
</template>

